
import React from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Clock, Book, Award, Brain } from "lucide-react";

interface AssessmentDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onStart: () => void;
  skillName: string;
}

export const AssessmentDialog = ({ isOpen, onClose, onStart, skillName }: AssessmentDialogProps) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="text-xl">Start {skillName} Assessment</DialogTitle>
          <DialogDescription>
            You're about to begin the assessment for {skillName}. Make sure you're prepared and have enough time to complete it.
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4 my-3">
          <div className="flex items-center justify-between">
            <div className="flex items-center">
              <Clock className="w-4 h-4 mr-2 text-purple-600" />
              <span>Time Limit</span>
            </div>
            <Badge variant="outline" className="bg-purple-50 text-purple-700">60 minutes</Badge>
          </div>

          <div className="flex items-center justify-between">
            <div className="flex items-center">
              <Book className="w-4 h-4 mr-2 text-blue-600" />
              <span>Questions</span>
            </div>
            <Badge variant="outline" className="bg-blue-50 text-blue-700">40 questions</Badge>
          </div>

          <div className="flex items-center justify-between">
            <div className="flex items-center">
              <Award className="w-4 h-4 mr-2 text-emerald-600" />
              <span>Certificate</span>
            </div>
            <Badge variant="outline" className="bg-emerald-50 text-emerald-700">Available</Badge>
          </div>

          <div className="flex items-center justify-between">
            <div className="flex items-center">
              <Brain className="w-4 h-4 mr-2 text-amber-600" />
              <span>Passing Score</span>
            </div>
            <Badge variant="outline" className="bg-amber-50 text-amber-700">70%</Badge>
          </div>
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={onClose}>
            Cancel
          </Button>
          <Button onClick={onStart} className="bg-purple-600 hover:bg-purple-700">
            Start Assessment
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
